module.exports = __webpack_public_path__ + "img/roses.944437e.svg";